import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Banner({ app }) {
  return (
    <Box className="release-hero">
      <Box className="release-hero__meta">
        <span className="hero-status-dot" />
        <span className="hero-status-label">Release notes</span>
      </Box>
      <Typography variant="h1" className="release-hero__title">
        Retalia changelog
      </Typography>
      <Typography className="release-hero__copy">
        Product updates, fixes, and API notices from the latest published
        releases.
      </Typography>
    </Box>
  );
}
